import "@/components/workspace/workspace.css";
import {
	Workspace,
	type WorkspaceConfig,
	useWorkspaceContext,
} from "@/components/workspace";
import { useGlobalDiagnosticsShortcuts } from "@/hooks/use-diagnostics-shortcuts";
import { ModuleErrorBoundary } from "@/components/ModuleErrorBoundary";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { useMemo } from "react";

export const Route = createFileRoute("/diagnostics")({
	component: DiagnosticsLayout,
});

function DiagnosticsWorkspaceInner() {
	const { statusBar } = useWorkspaceContext();
	useGlobalDiagnosticsShortcuts();

	const config = useMemo<WorkspaceConfig>(
		() => ({ menuBar: [], statusBar }),
		[statusBar],
	);

	return (
		<Workspace config={config}>
			<ModuleErrorBoundary>
				<Outlet />
			</ModuleErrorBoundary>
		</Workspace>
	);
}

function DiagnosticsLayout() {
	return <DiagnosticsWorkspaceInner />;
}
